import React from "react";
import { object } from "prop-types";

import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";
import NewsWithVideo from "../../molecules/NewsWithVideo";
import ComponentContainer from "../../layouts/component-container";

import { componentProps, getSlotId } from "../../utils/utils";

import "./bigVideoStoryCard2Ad.m.css";

const BigVideoStoryCard2Ad = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [], adSlot, autoPlay = false, layoutName } = componentProps(collection);

  const stories = items.filter((item) => item.type === "story").map(({ story }) => story);

  if (!stories.length) return null;

  const [firstStory, ...remainingStories] = stories;

  return (
    <ComponentContainer collection={collection}>
      <div styleName="wrapper">
        <NewsWithVideo
          story={firstStory}
          aspectRatio={[16, 9]}
          cssStyleName="bigSize"
          imageType="image16x9"
          autoPlay={autoPlay ? 1 : 0}
          showExcerpt={true}
          widths={[400, 580, 960]}
        />
        <div>
          <DfpContainer>
            <div styleName="side-ad" className="adsBox">
              <DfpComponent
                type={adSlot}
                collectionSlug={collection.slug}
                slotId={getSlotId(adSlot, collection?.slug, "big-video-story-card")}
                layoutName={layoutName}
              />
            </div>
          </DfpContainer>
          <div styleName="side-story-wrapper">
            {remainingStories.map((story, index) => (
              <LeftImageRightNews
                story={story}
                key={index}
                aspectRatio={[16, 9]}
                imageType="image16x9"
                widths={[200, 250, 200]}
              />
            ))}
          </div>
        </div>
      </div>
    </ComponentContainer>
  );
};

BigVideoStoryCard2Ad.propTypes = {
  collection: object,
};

BigVideoStoryCard2Ad.storyLimit = 5;

export default BigVideoStoryCard2Ad;
